import {Role} from '../enum/role';
import {CompanyDto} from './company-dto';
import {AccountStatus} from '../enum/account-status';

export class UserDto {

  public id: string | null = null;

  public firstname: string;

  public lastname: string;

  public email: string;

  public roles: Role[];

  public keycloakId: string | null = null;

  public accountStatus: AccountStatus;

  public company: CompanyDto;

  public manager: UserDto | null = null;

  public totalUsers: number = 0;

  constructor(id: string | null, firstname: string, lastname: string, email: string, roles: Role[], keycloakId: string | null, accountStatus: AccountStatus, company: CompanyDto) {
    this.id = id;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.roles = roles;
    this.keycloakId = keycloakId;
    this.accountStatus = accountStatus;
    this.company = company;
  }
}
